<div layout-vertical>
  <div layout-vertical padding-bottom-medium>
    <ng-content select="[header]"></ng-content>
  </div>

  <div layout-vertical *ngFor="let role of roles; trackBy: roleTrackBy">
    <rt-divider variant="line"></rt-divider>
    <div layout-horizontal layout-space-between padding-tb-medium>
      <div>{{ role.name }}</div>
      <div layout-horizontal>
        <ng-container *ngFor="let ability of abilities; let i = index; trackBy: abilityTrackBy">
          <rt-checkbox
            [checked]="roleAbilityChecked(role, ability)"
            [disabled]="disabled"
            (valueChange)="setRoleAbility(role, ability, $any($event))"
            margin-left-medium
          >
            {{ ability.label }}
          </rt-checkbox>
        </ng-container>
      </div>
    </div>
  </div>
</div>
